export default __webpack_public_path__ + "static/TSD_Blog_Hero_Holiday_Shopping_Season-3321d06f514bf7046cd92c0e7247d5d4.jpg";